import React, { useState, useEffect } from 'react';
import { X, Menu, Cookie } from 'lucide-react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';


const Navigation = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
  
    return (
      <nav className="bg-gray-900 text-white">
        <div className="container mx-auto flex justify-between items-center p-4">
          <div className="text-2xl font-bold">Starkling Art Watercolour Gallery</div>
          
          <div className="md:hidden">
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="focus:outline-none"
            >
              <Menu size={24} />
            </button>
          </div>
  
          <div className="hidden md:flex space-x-6">
            <a href="/" className="hover:text-blue-300">Home</a>
                     <a href="./about" className="hover:text-blue-300">About</a>
               <a href="./contact" className="hover:text-blue-300">Contact</a>
          </div>
  
          {isMenuOpen && (
            <div className="absolute top-16 left-0 right-0 bg-gray-900 md:hidden">
              <div className="flex flex-col items-center space-y-4 p-4">
                <a href="./artgallery2" className="hover:text-blue-300">Home</a>
                       <a href="./about" className="hover:text-blue-300">About</a>
                <a href="./contact" className="hover:text-blue-300">Contact</a>
              </div>
            </div>
          )}
        </div>
      </nav>
    );
  };
  const Footer = () => {
    return (
      <footer className="bg-gray-900 text-white text-center py-4">
        <p className="mb-2">&copy; 2024 Starkling Solutions. All rights reserved.</p>
        <div className="flex justify-center space-x-6">
          <a href="#" className="hover:text-blue-300">
            Terms & Conditions
          </a>
          <a href="#" className="hover:text-blue-300">
            Privacy Policy
          </a>
        </div>
      </footer>
    );
  };
const ContactPage = () => {
  return (
    <div className="bg-gray-100 min-h-screen">
      <Navigation />
      
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-center mb-12 text-gray-800">
          About Starkling Art
        </h1>
        
        <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="p-8">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
               Contact Detals
              </h2>
              <p className="text-gray-600 leading-relaxed">
                email : info@starklingsolutions.co.za
                              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                Let us get back to you
              </h2>
              <p className="text-gray-600 leading-relaxed">
                Malinda du Preez is a talented artist based in South Africa. Her work explores the interplay of light, color, and emotion, capturing landscapes that range from serene mountain scenes to dynamic urban reflections. Each painting tells a unique story, inviting viewers to explore the world through her artistic lens.

              </p>
            </section>
            
            
          </div>
        </div>
        
        <div className="text-center mt-12">
          <h3 className="text-2xl font-semibold text-gray-800 mb-6">
            Connect With Us
          </h3>
          <div className="flex justify-center space-x-6">
            <a 
              href="mailto:info@starklingsolutions.co.za" 
              className="text-blue-500 hover:text-blue-600 text-lg"
            >
              info@starklingsolutions.co.za
            </a>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};
export default ContactPage;